import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Logger } from './logger-service';
import { AdminConfigModel } from "src/app/models/shared-models";
@Injectable({
  providedIn: 'root'
})
export class AppInfoService {
  constructor(protected http: HttpClient, private logger: Logger) { }

  public appInfo$(): Observable<string> {
    const url = `${environment.apiUrl}`.replace('/api', '/appInfo');
    return this.http.get<any>(url)
      .pipe(map(result => {
        this.logger.info('app Info', result);
        return result.appVersion + ' ' + result.appEnvironment;
      }));
  }

  public appBannerMainPage$(): Observable<AdminConfigModel | null> {
    const url = `${environment.apiUrl}/app-banner-main-page`;
    return this.http.get<AdminConfigModel>(url);
  }

}
